<template>
    <div class="w-100">
        <div class="col-12 col-md-12">
            <div class="row m-0 no-gutters">
                <div class="col-12 col-md-6 pr-md-3 mb-4 mb-md-0">
                    <div class="card transparentBG border-0 p-0 cardLoyalty mb-0">
                        <div class="card-body p-3 whiteBG d-flex justify-content-between align-items-center mb-0">
                            <div class="d-flex align-items-center LeftCredit">
                                <figure class="imagesArea">
                                    <span class="hex" :class="loyalityCardDetail[0].level.toLowerCase()">
                                        <feather type="star"></feather>
                                    </span>
                                </figure>
                                <div>
                                    <h6>{{$t('loyal_card_det_You_are_a')}}</h6>
                                    <h5 class="mt-0">{{loyalityCardDetail[0].level}} {{$t('loyal_card_det_member')}}</h5>
                                    <h4><span>{{loyalityCardDetail[0].active_points}}</span> {{$t('loyal_card_det_Points')}} </h4>
                                </div>
                            </div>

                            <div class="text-right lastCredir">
                                <p class="mb-0">{{$t('loyal_card_det_Last_Credit_On')}}:</p>
                                <h5 class="mt-0" v-if="Object.keys(loyalityLastCredit).length > 0 && loyalityLastCredit.totalRecords > 0">{{loyalityLastCredit.records[0].created | moment("DD MMMM YYYY")}}</h5>
                                <h5 v-else> -</h5>
                            </div>
                          
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 pl-md-3">
                    <div class="card transparentBG border-0 p-0 cardLoyalty mb-0 ">
                        <div class="card-body p-3 whiteBG mb-0">
                            <div class="d-flex justify-content-between mb-2">
                                <div class="clubarea"  v-for="(value,key) in $env_var.loyalty_point_level">
                                    <h3 class="mb-0">{{value}}</h3>
                                    <p class="mb-0"><span>{{key}}</span> 
                                        <!-- {{$t('loyal_card_det_Points')}}  -->
                                    </p>
                                </div>
                            </div>
                            <div class="position-relative">
                                <div class="progress w-100 mb-3">
                                    <div class="progress-bar" v-bind:style="{ width: $parent.pointsCompletedFunc()+'%'}"></div>
                                    <div class="progressCheck d-flex justify-content-between w-100 align-items-center">
                                        <div class="checkBox " :class="(parseFloat($parent.pointsCompletedFunc()) >= 0)? 'selected' : ''"><feather type="check"></feather></div>
                                        <div class="checkBox" :class="(parseFloat($parent.pointsCompletedFunc()) >= 33.3)? 'selected' : ''"><feather type="check"></feather></div>
                                        <div class="checkBox" :class="(parseFloat($parent.pointsCompletedFunc()) >= 66.6)? 'selected' : ''"><feather type="check"></feather></div>
                                        <div class="checkBox" :class="(parseFloat($parent.pointsCompletedFunc()) >= 99.9)? 'selected' : ''"><feather type="check"></feather></div>
                                    </div>
                                </div>
                            </div>
                            <p class="mb-0">{{$t('loyal_card_det_Earn')}} {{$parent.nextLevel}} {{$t('loyal_card_det_more_points_to_jump_to')}} {{$parent.nextLevelName}} {{$t('loyal_card_det_gain_add_benefi')}}</p>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    	<!-- <div class="col-12 col-md-12">
        	<div class="row m-0 no-gutters">
        		<div class="col-12 col-md-4 pr-2">
        			<div class="walletPage-history media colorOne whiteBG border-radius py-3 card border-0 h-100">
        				<div class="card-body p-0 d-flex justify-content-between align-items-center w-100">
    						<div class="media-point">
    						  	<h5 class="mt-0">{{loyalityCardDetail[0].active_points}} <span>Point</span></h5>
    						  	<p class="mb-0">Total available</p>
    						</div>
    						<span class="imagesArea"><img src="../../../../../static/fxView/images/loyalty-rewards.png" alt="image"></span>
    					</div>
        			</div>
        		</div>
        		<div class="col-12 col-md-4 px-2">
        			<div class="walletPage-history media colorTwo whiteBG border-radius py-3 card border-0 h-100">
        				<div class="card-body p-0 d-flex justify-content-between align-items-center w-100">
    						<div class="media-point">
    						    <h5 class="mt-0">{{loyalityCardDetail[0].level}}</h5>
    						  	<p class="mb-0">Club </p>
    						</div>
    						<span class="imagesArea"><img :src="'../../../../../static/fxView/images/'+loyalityCardDetail[0].level.toLowerCase()+'.png'" alt="image"></span>
    					</div>
        			</div>
        		</div>
        		<div class="col-12 col-md-4 pl-2">
        			<div class="walletPage-history media colorThree whiteBG border-radius py-3 card border-0 h-100">
        				<div class="card-body p-0 d-flex justify-content-between align-items-center w-100">
    						<div class="media-point">
    						  	<h5 class="mt-0">12-06-21</h5>
    						  	<p class="mb-0">Last Credit On</p>
    						</div>
    						<span class="imagesArea"><img src="../../../../../static/fxView/images/calendar.svg" alt="image"></span>
    					</div>
        			</div>
        		</div>
        		
        	</div>
        </div>

        <div class="col-12 mt-4" :class="$parent.transfetWallet?'d-none':' '">
            <h3 class="mb-3 d-flex ">Next Club  
                
            </h3>
            <div class="whiteBG border-radius p-3">
                <div class="row m-0">
                    <div class="col-12 col-md-2 text-center">
                        <p>Current Club </p>
                        <h4>{{$env_var.loyalty_point_level[1]}}</h4>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="barSusscess w-100">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <div class="valuseOne" v-for="(value,key) in $env_var.loyalty_point_level"><p>{{key}} <span v-if="key > 1 && key <= 1250">{{value}}</span></p></div>
                            </div>
                            <div class="progress w-100">
                                <div class="progress-bar" v-bind:style="{ width: $parent.pointsCompletedFunc()}"></div>
                            </div>
                            <div class="eanrn text-center" v-if="$parent.nextLevel != ''">
                                <p>Earn {{$parent.nextLevel}} more points to jump to next category to gain additional benefits</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 text-center">
                        <p>Next Club </p>
                        <h4>{{$env_var.loyalty_point_level[6000]}}</h4>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
    export default {
        name: 'Wallet',
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyality/loyality_card_detail.vue